import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// PWA/SW hanya aktif di production (npm run build).
// Di development (npm start) otomatis di-unregister & cache dibersihkan.
serviceWorkerRegistration.register();
